import React, { useEffect, useState, useRef } from 'react';
import { fetchDiscountAE, createDiscountAE, updateDiscountEndDate } from '../../../../services/discount';
import { Table, Input, Button, Row, Form, DatePicker, Select, Tooltip, Col, Typography, Modal, Divider, InputNumber, message } from 'antd';
import { SearchOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useSelector, connect } from 'react-redux';
import { State, States } from 'sigt';
import Highlighter from 'react-highlight-words';
import handlingMessage from '../../../../utils/handlingMessage';
import Item from 'antd/lib/list/Item';

const EditableCell:React.FC<EditableCellProps | any> = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps
}) => {
  const inputNode = <DatePicker format='DD-MM-YYYY' style={{textAlignLast:'center'}} />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{margin: 0}}
          rules={[{required: true,message: `Por favor ingresar ${title}!`,}]}>
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const round2 = (number: number | string) =>{
  number = (typeof number !== 'number') ? parseFloat(number) : number
  return Math.round(((number) + Number.EPSILON) * 100) / 100
} 

const DiscountAE: React.FC<DiscountAEProps> = ({ ae, brch }) => {
  const [discountAE, setDiscountAE] = useState<actividades[]>([]);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColum] = useState('');
  const [loading, setLoading] = useState(true);
  const searchInput = useRef<any>(null);
  const { thm } = useSelector((state: State) => ({ thm: state.thm }));
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = record => record.key === editingKey;

  const allowedBranch = [8,64];

  const getExoneracionesAE = async () => {
    const { descuentos } = await fetchDiscountAE();
    setDiscountAE(descuentos.map((ele, index) => ({...ele, key: index})));
    setLoading(false);
  }

  useEffect(() => {
    getExoneracionesAE();
  }, []);

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder='Buscar'
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size='small'
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size='small' style={{ width: 90 }}>
          Restablecer
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined onClick={() => {}} style={{ color: filtered ? thm.primaryColor : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        if (searchInput.current) {
          searchInput.current?.select();
        }
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#1e72c675', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColum(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const columnsDiscountAE: ColumnsType<actividades> | any = [
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      ...getColumnSearchProps('descripcion'),
    },
    {
      title: 'Fecha de inicio',
      dataIndex: 'fechaInicio',
      key: 'fechaInicio',
      ...getColumnSearchProps('fechaInicio'),
      render: (text) => moment(text).utcOffset('+0400').format('DD-MM-YYYY')
    },
    {
      title: 'Fecha Fin',
      dataIndex: 'fechaFin',
      key: 'fechaFin',
      editable:true,
      ...getColumnSearchProps('fechaFin'),
      render: (text) => text ? moment(text).utcOffset('+0400').format('DD-MM-YYYY'): 'No definida',
    },
    {
      key: "action",
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Tooltip placement="bottom" title="Confirmar">
              <Button type="link" icon={<CheckOutlined />} onClick={() => save(record.id)} />
            </Tooltip>
            <Tooltip placement="bottom" title="Cancelar">
              <Button type="link" icon={<CloseOutlined />} onClick={() => setEditingKey('')} />
            </Tooltip>                        
          </span>
        ) : (
            <span>
            <Tooltip placement="bottom" title="Editar">
              <Button type="link" icon={<EditOutlined />} onClick={() => edit(record)} />
            </Tooltip>
          </span>
        );
      },
    }
  ];

  const expandedRowRender = ({ramos,id}) => {
    const columns: ColumnsType<any> = [
      { title: 'Ramo', dataIndex: 'ramo', key: 'ramo'},
      { title: 'Descuento', dataIndex: 'porcentaje', align: 'center', key: 'porcentaje', render: (descuento) => `${round2(parseFloat(descuento) * 100)}%`}
    ];
    return <Table size='middle' style={{ margin: '4px 0 4px 83px' }} key={id} rowKey={({id}) => id} columns={columns} dataSource={ramos} pagination={false} />;
  };
  
  const mergedColumns = columnsDiscountAE.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        inputType: 'date',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record)
      })
    };
  });
  
  const edit = (record) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const save = async (key) => {
    try {
      const row = await editForm.validateFields();
      const newData = [...discountAE];
      const index = newData.findIndex(item => key === item.id);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        const values = newData[index];
        handlingMessage({
          action: () => updateDiscountEndDate({to:moment(values.fechaFin).startOf('day').format('MM/DD/YYYY'),id:values.id}),
          key:'endDiscount',
          loadingMessage: 'Actualizando Descuento',
          cb: () => {
            setDiscountAE(newData);
          }
        });
        setEditingKey('');
      }
      
    } catch (errInfo) {
      throw errInfo;
    }
  };

  const onSubmitDiscount = async () => {
    let values = await form.validateFields();
    if (!values.ramos) return message.error('Debe agregar al menos 1 ramo');
    else{
      values.ramos = values.ramos.map((r) => ({id: r.ramo, porcDescuento: round2(r.porcDescuento / 100), descripcion: brch.branches.find((b) => b.id === r.ramo)?.descripcion }));
    }
    setLoading(true);
    const activities = values.activities.map((id) => {
      const act = ae?.activities.find((l) => l.id === id);
      return {id: act?.id, nombreActividad: act?.descripcion, ramos: values.ramos};
    })

    handlingMessage({
      action: () => createDiscountAE({ activities, from: moment(values.from).startOf('day').format('MM/DD/YYYY') }),
      key: 'createDiscount',
      loadingMessage: 'Creando descuento...',
      cb: ({actividades}) => {
        if(actividades){
          setDiscountAE([...actividades, ...discountAE]);
          form.resetFields();
          setVisible(false);
        }
        setLoading(false);
      },
    });
  };

  const components = {
    body: {
      cell: EditableCell,
    }
  };
  
  const firstListItem = (fields, add) => {
    if(fields.length === 0) {
      setTimeout(() => add(), 10);
    }
  }

  return (
    <>
      <Row justify='space-between' gutter={[16,8]}>
        <Col><Typography.Text style={{fontSize: 19}}>Descuentos por aforo</Typography.Text></Col>
        <Col><Button type='primary' onClick={()=>setVisible(true)} icon={<PlusCircleOutlined/>}>Agregar Descuento</Button></Col>
      </Row>
      <Form form={editForm}>
        <Table rowKey={({id}) => id} size='middle' loading={loading} columns={mergedColumns} components={components} dataSource={discountAE} expandable={{expandedRowRender}} />
      </Form>
      <Modal bodyStyle={{height: '70vh', overflowY: 'scroll'}} centered onOk={onSubmitDiscount} width={700} okText='Finalizar' confirmLoading={loading} visible={visible} onCancel={()=>setVisible(false)} title='Nuevo Descuento'>
        <Form initialValues={{ from: moment() }} form={form} layout='vertical'>
          <Row gutter={[16, 8]} align='middle'>
            <Col span={24}>
              <Form.Item label='Fecha inicio' name='from' rules={[{required: true, message: 'Debe seleccionar una fecha de inicio.'}]}>
                <DatePicker format={'DD-MM-YYYY'} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label='Actividad Economica'
                name='activities'
                rules={[{ required: true, message: 'Debe seleccionar al menos una actividad' }]}
              >
                <Select placeholder='Seleccione las actividades economicas a descontar...' allowClear filterOption={(value: string, option) => option?.title?.includes(value.toUpperCase())} style={{ width: '100%' }} mode='multiple'>
                  {ae.activities?.map(({ id, descripcion }) =>
                    <Select.Option key={id} value={id} title={descripcion.toUpperCase()}>
                      <Tooltip title={descripcion}>{descripcion.toUpperCase()}</Tooltip>
                    </Select.Option>
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Divider style={{ marginLeft: -15 }} orientation='left'>Ramos</Divider>
              {<Form.List name='ramos'>
                {(fields, { add, remove }) => (
                  <div>
                    {firstListItem(fields, add)}
                    <Row gutter={[16,8]}> 
                      {fields.map((field, index) => (
                        <React.Fragment key={index}>
                          <Col xs={24} xl={20}>
                            <Form.Item label='Ramo' name={[field.name, 'ramo']} rules={[{required:true, message: 'Debe seleccionar un ramo...'}]}>
                              <Select style={{ width: '100%' }} placeholder='Seleccione Ramo...'>
                                {brch.branches.map((b) => allowedBranch.includes(b.id) ? (<Select.Option key={b.id} value={b.id} title={b.descripcion}>{b.descripcion}</Select.Option>) : null)}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} xl={4}>
                            <Form.Item name={[field.name, 'porcDescuento']} label='Descuento' rules={[{ required: true, message: 'Por favor ingrese un valor de descuento' }]}>
                              <InputNumber style={{width: '100%'}} min={0} max={100} step={1} />
                            </Form.Item>
                          </Col>
                          <Divider/>
                        </React.Fragment>
                      ))}
                    </Row>
                    <Row gutter={[16, 8]} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Col><Button type='dashed' onClick={() => add()}>Agregar ramo</Button></Col>
                      {fields.length > 1 && <Col><Button type='danger' onClick={() => remove(fields.length - 1)}>Eliminar ramo</Button></Col>}
                    </Row>
                  </div>
                )}
              </Form.List>}
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: State) => ({ ae: state.ae, brch: state.brch });

export default connect(mapStateToProps)(DiscountAE);

interface DiscountAEProps {
  ae: States.AES;
  brch: States.Branches;
}

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: string;
  record: Item;
}

interface actividades {
  key: number;
  id: number;
  numeroReferencia?: number;
  descripcion: string;
  fechaInicio?: string;
  fechaFin?: string;
  ramos: { id:number, ramo: string, porcentaje: string }[];
}
